export default {
  name: "shippop",
  webTitle: "POP SHIPPOP",
  // primaryColor: "#11cdef",
  // secondaryColor: "#11cdefb0",
  backgroundColor: "#0b9dd1",
  contactURL: "https://lin.ee/oPJTwpD",
  bannerPrefix: "POP",
  shopCodePrefix: "PS",
  showChangelog: true,
  serviceName: {
    inter: false,
    lazada: true,
    dhl: true,
    shippop: true,
    shopee: true,
    doubleA: true,
    kerry: true,
    kerry_quick: false,
    kerry_orange: false,
    flash_dropoff: true,
    line: true,
  },
  manageVision: {
    brancePackage: true,
    menuTopUpCreditSA: true,
  },
  unitKG: false,
  manageDisable: {
    weightSuperAdmin: false,
    dimensionSuperAdmin: false,
    costSuperAdmin: false,
  },
  dropoffKerry: false,
  dropoffOrange: false,
  dropoffEasyShip: true,
  dropoffKerryOption: {
    limit: 50,
    manual:
      "https://docs.google.com/presentation/d/1sralwUyDy9um2pq8-a-mkJRbiHLpYLIRyZJwkRu7ygU/edit?usp=sharing",
    vdoHowTo: "https://shippop.live/kerrydop",
  },
  customDropoffOption: {
    LZDS: {
      limit: 50,
      manual: "https://docs.google.com/presentation/d/1gia8o9vSf5zK04MndA4jWAUnDjvL6kP-R0PoJ_TQ0TM/edit#slide=id.g25c69e5d5ed_0_5",
      vdoHowTo: "https://drive.google.com/file/d/1_8Rh18xN8z3E6pbaoEkgDaIv7i9tB-sY/preview"
    }
  },
  dropoffFlashOption: {
    limit: 50,
    manual: "",
    vdoHowTo: ""
  },
  bannerCampaignPosition: "DF_POSPOPSHOP",
  btnCancelBill: false,
  failReport: true,
  pdpa: {
    urlTermsOfUseShop:
      "https://www.shippop.com/terms",
    privacyPolicyShop:
      "https://www.shippop.com/privacy",
  },
  menuLayout: {
    reportInvoice: true,
    reportReceipt: true
  },
  LineConfig: {
    shopBank: true,
  }
};
